<template>
    <DSSwitches
        v-for="item in terms"
        :key="`checkbox-${item.value}`"
        v-model="order.data.value[item.value]"
        type="checkbox"
        :options="[item]"
    />
    <a
        class="terms-link"
        href="https://helmisimpukka.fi/ennakkotilaus/ennakko-ja-ryhmatilauksen-ehdot"
        target="_blank"
        rel="noopener noreferrer"
    >{{ t('step4.readTerms') }}</a>
</template>
<script setup>
import { inject, useI18n } from '#imports';

const order = inject('order');
const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            step4: {
                emailVerified: 'Olen tarkistanut sähköpostiosoitteeni.',
                termsAndConditions: 'Hyväksyn ryhmätilauksen ehdot',
                readTerms: 'Lue käyttöehdot',
            },
        },
    },
});

const terms = [
    { label: t('step4.emailVerified'), value: 'emailVerified' },
    { label: t('step4.termsAndConditions'), value: 'terms' },
];
</script>
<style scoped>
.terms-link {
  color: var(--color-primary-500);
  text-decoration: underline;
  font-weight: 700;
  position: relative;
  top: -1rem;
  left: 2rem;
}
</style>
